import BusRentFaq from "@Pages/busRent/components/BusRentFaq";
import PopularLocations from "@Pages/busRent/components/PopularLocations";
import BusRentContactForm from "@Pages/busRent/components/BusRentContactForm";

function BusRent() {
    return (
        <>
            <BusRentContactForm/>
            <PopularLocations/>
            <BusRentFaq/>
        </>
    )
}

export default BusRent